import React from "react";
import { BoatImg } from "../assets/photos";
import { PagesBanner } from "../components/PagesBanner";
import {
  contactUsDescriptionLabel,
  contactUsLabel,
} from "../constants/translations";
import { ContactSection } from "../components/contacts/ContactSection";
import { ContactMap } from "../components/contacts/ContactMap";

export const ContactPage = ({ languageId }) => {
  return (
    <>
      <PagesBanner
        title={contactUsLabel[languageId]?.label || "Contact Us"}
        description={
          contactUsDescriptionLabel[languageId]?.label ||
          "Get in touch with us for any inquiries or assistance."
        }
        image={BoatImg}
      />
      <ContactSection languageId={languageId} />
      <ContactMap />
    </>
  );
};
